<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar>
                        <v-toolbar-title>{{ reportNumber }}</v-toolbar-title>
                        
                        <v-tabs v-model="tab">
                            <v-tab value="general">General</v-tab>
                            <v-tab value="details">Details</v-tab>
                        </v-tabs>
                    </v-toolbar>
                    <v-progress-linear indeterminate :active="loading"></v-progress-linear>
                    <v-tabs-window v-model="tab">
                        <v-tabs-window-item value="general">
                            <v-card-text>
                                
                                <v-row class="mt-2 mb-2">
                                    <v-col sm="12" md="12" lg="6">
                                        <v-combobox variant="outlined" clearable item-title="name"
                                            item-value="companyID" density="compact" label="Combobox" :items="companies"
                                            v-model="selectedCompany" @update:search="onCompanyUpdate"></v-combobox>
                                        <location-combo-box density="compact" variant="outlined" :hide-details="false" v-model="location" label="Location" :companyId="companyId" :strict="true" :isLoaded="filterByCompany" ></location-combo-box>
                                        <project-combo-box density="compact" variant="outlined" :hide-details="false" v-model="project" label="Project" :companyId="companyId" :strict="true" :isLoaded="filterByCompany" ></project-combo-box>
                                        <v-select density="compact" variant="outlined" :items="shifts" v-model="shift" label="Shift"></v-select>
                                        <v-text-field variant="outlined" density="compact" label="Spent Time"
                                            v-model="spentTime"></v-text-field>
                                        <v-row>
                                            <v-col>
                                                <menu-date-picker label="Created Date" variant="outlined" v-model="createdDay" :hide-details="false" @update:model-value="onPeriodUpdate" ></menu-date-picker>
                                            </v-col>
                                            <v-col>
                                                <menu-time-picker label="Time" variant="outlined" v-model="createdTime" :hide-details="false" @update:model-value="onPeriodUpdate" ></menu-time-picker>
                                            </v-col>
                                        </v-row>
                                        <v-textarea label="Note" variant="outlined" v-model="note"></v-textarea>
                                        <v-row>
                                            <v-col md="12" lg="9" xl="6">
                                                <v-card :subtitle="member.email" :title="member.name"
                                                    color="secondary">
                                                    <template v-slot:prepend>
                                                        <v-avatar color="blue-darken-2">
                                                            <v-icon icon="mdi-account"></v-icon>
                                                        </v-avatar>

                                                    </template>
                                                    <v-card-text>
                                                        <label>Created on:</label> <span>{{ formatDate(createdDate) }}</span>
                                                    </v-card-text>

                                                </v-card>
                                            </v-col>
                                            <v-col  cols="0"  md="0" lg="3" xl="6"></v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="0" sm="0" md="0" lg="6">

                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn variant="elevated" class="ml-2 mr-3"
                                    @click="$router.push('/reports')">Back</v-btn>
                                <v-btn variant="elevated" color="primary" class="mr-3" @click="save">Save</v-btn>
                            </v-card-actions>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="details">
                            <v-card-text>
                                <v-row >
                                    <v-col>
                                        <v-btn prepend-icon="mdi-plus" variant="outlined" class="mr-3" :to="`/reports/${this.id}/details/create`" >Create</v-btn>
                                    </v-col>
                                </v-row>
                                <v-table>
                                    <colgroup>
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                        <col style="width: 150px;" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Part</th>
                                            <th class="text-left">Lot</th>
                                            <th class="text-left">Box</th>
                                            <th class="text-left">Units in Box</th>
                                            <th class="text-left">Ok</th>
                                            <th class="text-left">Defects</th>
                                            <th class="text-left">Created on</th>
                                            <th >Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in details" :key="item.reportDetailId">
                                            <td>{{ item.partNumber }}</td>
                                            <td>{{ item.lotNumber }}</td>
                                            <td>{{ item.boxNumber }}</td>
                                            <td>{{ item.boxUnits }}</td>
                                            <td>{{ item.goodPartsUnit }}</td>
                                            <td>{{ item.defectTotalCount }}</td>
                                            <td>{{ formatDate(item.createdDate) }}</td>
                                            <td>
                                                <v-btn icon="mdi-pencil" variant="text"
                                                    :to="`/reports/${item.reportId}/details/${item.reportDetailId}`"></v-btn>
                                                <v-btn icon="mdi-delete" variant="text"
                                                    @click="deleteEnity(item.reportDetailId, item.partNumber)"></v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-table>
                                <v-divider></v-divider>
                                <v-toolbar color="surface">
                                    <v-toolbar-title></v-toolbar-title>
                                    <span density="compact" class="mr-3 free-text">Item per page:</span>
                                    <v-select variant="outlined" 
                                    density="compact" 
                                    hide-details 
                                    :items="perPageItems" 
                                    v-model="perPage" 
                                    style="max-width: 6rem;"
                                    @update:modelValue="loadReset" ></v-select>
                                    <span density="compact" class="ml-4 mr-4 free-text">{{offset + 1 }} - {{ curentPage() }} of {{ count }}</span>
                                    <v-btn icon="mdi-arrow-left" density="compact" variant="text" :disabled="offset == 0" @click="previousPage" ></v-btn>
                                    <v-btn icon="mdi-arrow-right" density="compact" variant="text" class="ml-4 mr-12" :disabled="curentPage() >= count" @click="nextPage" ></v-btn>
                                </v-toolbar>
                            </v-card-text>
                        </v-tabs-window-item>
                    </v-tabs-window>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog max-width="500" v-model="dialogOn">
            <v-card title="Delete Report Item">
            <v-card-text>Are you sure you whant to delete entry {{ reportDetailName }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text="Dismist" @click="dialogOn = false"></v-btn>
                <v-btn text="Delete" color="error" @click="confirmDelete"></v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar">{{ message }}
            <template v-slot:actions>
                <v-btn icon="mdi-close" variant="text" @click="snackbar = false" :timeout="timeout"></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import ReportApi from '../services/ReportApi'
import MemberApi from '../services/MemberApi'
import ReportDetailsApi from '../services/ReportDetailsApi'
import CompanyApi from '@/services/CompanyApi';
import LocationComboBox from '@/components/LocationComboBox.vue';
import ProjectComboBox from '@/components/ProjectComboBox.vue';
import MenuDatePicker from '@/components/MenuDatePicker.vue'
import MenuTimePicker from '@/components/MenuTimePicker.vue';
import moment from 'moment';
import { useStore } from '../services/store'

export default {
    name: 'ReportEdit',
    data() {
        return {
            id: 0,
            reportNumber: "",
            spentTime: "",
            note: "",
            location: null,
            project: null,
            shift: null,
            selectedCompany: null,
            member: { },
            companies: [],
            createdDate: "",
            createdDay: "",
            createdTime: "",
            message: "",
            snackbar: false,
            timeout: 2000,
            tab: "general",
            details: [],
            perPage: 15,
            perPageItems: [ 10, 15, 25, 50 ],
            shifts: [1, 2, 3],
            offset: 0,
            reportDetailId: 0,
            reportDetail: '',
            dialogOn: false,
            loading: false,
            filterByCompany: false
        }
    },
    components:{
        LocationComboBox,
        ProjectComboBox,
        MenuDatePicker,
        MenuTimePicker
    },
    computed: {
        companyId() {
            return ( this.selectedCompany && this.selectedCompany.companyID > 0 ) ? this.selectedCompany.companyID : null;
        }
    },
    mounted() {
        const store = useStore();
        if(store.showDetails == true) {
            this.tab = "details";
            store.showDetails = false;
        }
        
        this.perPage = store.perPage;
        var id = this.$route.params.id;
        this.id = id;
        if (!isNaN(id)) {
            this.title = "Edit";
            this.loading = true;
            ReportApi.get(this.id, this.offset, this.perPage).then((response) => {
                if (response && response.data) {
                    this.reportNumber = response.data.reportNumber;
                    this.id = response.data.reportId;
                    this.memberId = response.data.memberId;
                    if(response.data.company) 
                        this.selectedCompany = { companyID: response.data.company.companyId, name: response.data.company.name }
                    this.shift = response.data.shift;
                    this.location = response.data.location;
                    this.project = response.data.project;
                    this.spentTime = response.data.spentTime;
                    this.note = response.data.note;
                    this.createdDate = new Date(response.data.createdDate);
                    
                    this.member = response.data.member
                    this.setDateTimeFromServer();
                    
                }
            }).finally(() => { this.loading = false; setTimeout(() => { this.filterByCompany = true; }, 1000)  })

            this.load();
        }
        else {
            this.title = "Create";
            MemberApi.userInfo().then((response) => {
                if(response.data) {
                    this.member = {  name: `${response.data.firstName} ${response.data.lastName}` , email: response.data.email };
                    this.memberId = response.data.memberId;
                }
            }).catch((ex) => {
                console.log(ex);
            }).finally(() => { this.loading = false; setTimeout(() => { this.filterByCompany = true; }, 50)  })

            this.createdDate = new Date();
        }

        this.serarchCompanies()
    },
    methods: {
        onCompanyUpdate(a) {
            this.serarchCompanies(a);
        },
        serarchCompanies(term) {
            CompanyApi.search({ offset: 0, limit: 25, search: term }).then((response) => {
                if (response && response.data && Array.isArray(response.data.companies)) {
                    this.companies = response.data.companies;
                }
            })
        },
        save() {
            
            if(!isNaN(this.id)) {
                ReportApi.put(this.id ,{
                    reportId: this.id,
                    memberId: this.memberId,
                    companyId: this.selectedCompany ? this.selectedCompany.companyID : 0,
                    locationId: this.location?.locationId,
                    projectId: this.project?.projectId,
                    createdDate: !this.createdDate ? null : this.createdDate,
                    shift: this.shift,
                    sheetStatus: 'Open',
                    spentTime: this.spentTime,
                    note: this.note
                })
                .then((response) => {
                    if(response.data && response.data.state) {
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                });
            }
            else {
                ReportApi.post({
                    reportId: 0,
                    companyId: this.selectedCompany.companyID,
                    locationId: this.location?.locationId,
                    projectId: this.project?.projectId,
                    shift: this.shift,
                    sheetStatus: 'Open',
                    spentTime: this.spentTime,
                    note: this.note
                })
                .then((response) => {
                    if(response.data && response.data.state) {
                        this.id = response.data.reportId;
                        this.$router.push(`/reports/${this.id}`);

                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                });
            }
        },
        formatDate(dt) {
            return moment(dt).format('DD.MM.YYYY HH:mm')
        },
        deleteEnity(id, name) {
            this.reportDetailId = id;
            this.reportDetailName = name;
            this.dialogOn = true;
        },
        loadReset() {
            this.offset = 0;
            const store = useStore();
            store.perPage = this.perPage;
            this.load();
        },
        load() {
            let output = this.offset == 0 ? 'count' : ''
            this.loading = true;
            ReportDetailsApi.search(this.id, { offset: this.offset, limit: this.perPage, output: output }).then((response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    this.details = response.data.items;
                    if(response.data.count != undefined)
                        this.count = response.data.count;
                }
            }).finally(() => { this.loading = false; });
        },
        nextPage() {
            this.offset += this.perPage;
            this.load()
        },
        curentPage() {
            let crtPage = this.offset + this.perPage;
            if(crtPage > this.count)
                return this.count;
            return crtPage;
        },
        previousPage() {
            this.offset -= this.perPage;
            this.load()
        },
        confirmDelete() {
            if(!this.reportDetailId)
            {
                this.message = 'Something gone wrong report details not found!'
                this.snackbar = true;
            } 
            else {
                ReportDetailsApi.delete(this.id, this.reportDetailId)
                    .then((response) => {
                            if(response.data && response.data.state){
                                this.message = response.data.state.message
                                this.snackbar = true;
                                this.dialogOn = false;
                                this.load();
                            }
                        })
            }
        },
        onPeriodUpdate() {
            let localFormat = moment.localeData(navigator.language).longDateFormat('l');
            if(moment(this.createdDay, localFormat).isValid()) {
                if(this.createdTime && this.createdTime.indexOf(":") != -1) {
                    this.createdDate = (new Date(moment(this.createdDay, localFormat).format("yyyy-MM-DD") + " " + this.createdTime + ":00")).toISOString();
                }
                else {
                    this.createdDate = (new Date(moment(this.createdDay, localFormat).format("yyyy-MM-DD") + " 00:00:00")).toISOString();
                }
            }
            else {
                this.createdDate = '';
            }
        },
        setDateTimeFromServer()
        {
            if(moment(this.createdDate, 'YYYY-MM-DD HH:mm:ssZ').isValid()) {
                this.createdDay = moment(this.createdDate, 'YYYY-MM-DD HH:mm:ssZ').format(moment.localeData(navigator.language).longDateFormat('l'));
                this.createdTime = moment(this.createdDate, 'YYYY-MM-DD HH:mm:ssZ').format("HH:mm");
            }
        }
    }
}
</script>